import React from 'react';
import gIcon from './G.svg.png';

const MyGoogleIcon = () => {
    return <img src={gIcon} alt="G icon" width="24" height="24" />;
};

export default MyGoogleIcon;